const pool = new Map()

function checkExpire() {
  for (const key of pool.keys()) {
    const entry = pool.get(key)
    if (Date.now() > entry.expire) {
      pool.delete(key)
    }
  }
}

/**
 * 存入缓存
 * @param {String} key 键名
 * @param {any} data 数据
 * @param {Number} [expire=120] 过期时间，单位为秒
 */
export function cacheSet(key, data, expire = 120) {
  if (typeof key !== 'string') {
    throw new TypeError('key must be string.')
  }
  if (typeof expire !== 'number' || expire < 0) {
    throw new TypeError('expire must be positive number.')
  }
  pool.set(key, {
    data,
    expire: Date.now() + expire * 1000,
  })
  if (pool.size > 100) {
    checkExpire()
  }
}

/**
 * 取缓存
 * @param {String} key 键名
 * @return {any} 缓存数据，若已过期或不存在则为null
 */
export function cacheGet(key) {
  const entry = pool.get(key)
  if (entry === undefined) {
    return null
  }
  if (Date.now() > entry.expire) {
    pool.delete(key)
    return null
  }
  return entry.data
}

/**
 * 取缓存，若无缓存则调用promise获取值
 * @param {String} key 键名
 * @param {GeneratorFunction} provider 数据提供者, async function
 * @param {Number} [expire=30] 过期时间，单位为秒
 * @return {any} 已有缓存或provider返回的数据
 */
export async function cacheGetDefault(key, provider, expire = 30) {
  let data = cacheGet(key)
  if (data !== null) {
    return data
  }
  let resolve
  const promise = new Promise((r) => {
    resolve = r
  })
  pool.set(key, {
    data: promise,
    expire: Date.now() + expire * 1000,
  })
  if (pool.size > 100) {
    checkExpire()
  }
  data = await provider()
  pool.set(key, {
    data,
    expire: Date.now() + expire * 1000,
  })
  // noinspection JSUnusedAssignment
  resolve(data)
  return data
}

/**
 * 销毁缓存
 * @param {String} key 键名
 */
export function cacheInvalidate(key) {
  pool.delete(key)
}

/* Add dump function in dev env. */
if (process.env.NODE_ENV === 'development') {
  window.dumpCache = () => {
    // eslint-disable-next-line no-console
    console.log(pool)
  }
}
